import request from "@/utils/request";

//1,添加用户
export function getJudges(data){
    return request({
        url:'/admin/getJudges',
        data:data,
        method:'get'
    })
}
//1,导出专家
export function exportJudges(data){
    return request({
        url:'/admin/exportJudges',
        data:data,
        method:'get'
    })
}
